import React from 'react';
import { 
  FaCheck, FaTimes, FaTrash, FaUser, FaTruck, FaExclamationCircle, 
  FaMoneyBill, FaBell, FaFileAlt, FaClock 
} from 'react-icons/fa';
import './NotificationItem.css';

const NotificationItem = ({ 
  notification, 
  onMarkAsRead, 
  onDelete, 
  onClick 
}) => {
  const handleMarkAsRead = (e) => {
    e.stopPropagation();
    if (!notification.is_read) {
      onMarkAsRead(notification.id);
    }
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    onDelete(notification.id);
  };

  const handleClick = () => {
    if (onClick) {
      onClick(notification);
    }
    if (!notification.is_read) {
      onMarkAsRead(notification.id);
    }
  };

  const getIcon = (type) => {
    const iconMap = {
      'mission_assigned': <FaTruck />,
      'mission_completed': <FaCheck />,
      'mission_cancelled': <FaTimes />,
      'payment_received': <FaMoneyBill />,
      'document_validation': <FaFileAlt />,
      'user_message': <FaUser />,
      'system_alert': <FaExclamationCircle />,
      'default': <FaBell />
    };
    return iconMap[type] || iconMap.default;
  };

  const getTypeColor = (type) => {
    const colorMap = {
      'mission_assigned': '#3498db',
      'mission_completed': '#27ae60',
      'mission_cancelled': '#e74c3c',
      'payment_received': '#f39c12',
      'document_validation': '#9b59b6',
      'user_message': '#1abc9c',
      'system_alert': '#e67e22',
      'default': '#95a5a6'
    };
    return colorMap[type] || colorMap.default;
  };

  const formatTimeAgo = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffInSeconds = Math.floor((now - date) / 1000);

    if (diffInSeconds < 60) {
      return 'À l\'instant';
    } else if (diffInSeconds < 3600) {
      const minutes = Math.floor(diffInSeconds / 60);
      return `Il y a ${minutes} min`;
    } else if (diffInSeconds < 86400) {
      const hours = Math.floor(diffInSeconds / 3600);
      return `Il y a ${hours}h`;
    } else if (diffInSeconds < 604800) {
      const days = Math.floor(diffInSeconds / 86400);
      return `Il y a ${days}j`;
    } else {
      return date.toLocaleDateString('fr-FR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    }
  };

  return (
    <div 
      className={`notification-item ${!notification.is_read ? 'unread' : 'read'}`}
      onClick={handleClick}
    >
      {/* Indicateur de lecture */}
      {!notification.is_read && <div className="unread-indicator"></div>}
      
      {/* Icône du type de notification */}
      <div 
        className="notification-icon" 
        style={{ backgroundColor: getTypeColor(notification.type) }}
      >
        {getIcon(notification.type)}
      </div>

      {/* Contenu de la notification */}
      <div className="notification-content">
        <div className="notification-header">
          <h4 className="notification-title">{notification.title}</h4>
          <div className="notification-time">
            <FaClock className="time-icon" />
            {formatTimeAgo(notification.created_at)}
          </div>
        </div>
        
        <p className="notification-message">{notification.message}</p>

        {/* Données supplémentaires si disponibles */}
        {notification.data && Object.keys(notification.data).length > 0 && (
          <div className="notification-metadata">
            {notification.data.mission_id && (
              <span className="metadata-item">
                Mission #{notification.data.mission_id.slice(-8)}
              </span>
            )}
            {notification.data.amount && (
              <span className="metadata-item">
                {notification.data.amount} FCFA
              </span>
            )}
            {notification.data.status && (
              <span className={`metadata-status status-${notification.data.status}`}>
                {notification.data.status}
              </span>
            )}
          </div>
        )}
      </div>

      {/* Actions */}
      <div className="notification-actions">
        {!notification.is_read && (
          <button
            className="action-btn mark-read-btn"
            onClick={handleMarkAsRead}
            title="Marquer comme lu"
          >
            <FaCheck />
          </button>
        )}
        <button
          className="action-btn delete-btn"
          onClick={handleDelete}
          title="Supprimer"
        >
          <FaTrash />
        </button>
      </div>
    </div>
  );
};

export default NotificationItem;